import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import styles from "../Modals.module.css"
import GroupChat from "../../GroupChat/GroupChat"
import ModalCloseButton from "../ModalCloseButton"

const GroupChatModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <>
          <ModalCloseButton handleClose={handleClose} />
          <Box className={styles.modal_container}>
            <GroupChat group={props.group} />
          </Box>
        </>
      </Modal>
    </div>
  )
})

export default GroupChatModal
